export enum UserType {
	Internal = 1,
	External = 2,
	AdUser = 3,
}
